import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { INewAncillaryForm } from 'features/Ancillaries/components/NewAncillaryForm/types'

const MIN_LENGTH = 4
const MAX_LENGTH = 32

const messages = defineMessages({
  required: {
    id: 'dictionary.field.required',
    defaultMessage: 'Field required'
  },
  min: {
    id: 'dictionary.value.min',
    defaultMessage: 'The value must be at least {min} characters long'
  },
  max: {
    id: 'dictionary.value.max',
    defaultMessage: 'The value must be at most {max} characters long'
  }
})

const stringValidation = (intl: IntlShape, minLength: number, maxLength: number): yup.StringSchema =>
  yup
    .string()
    .min(minLength, intl.formatMessage(messages.min, { min: minLength }))
    .max(maxLength, intl.formatMessage(messages.max, { max: maxLength }))

export const schema = (intl: IntlShape): yup.SchemaOf<INewAncillaryForm> => {
  return yup.object().shape({
    name: stringValidation(intl, MIN_LENGTH, MAX_LENGTH).required(intl.formatMessage(messages.required)),
    enLabel: stringValidation(intl, MIN_LENGTH, MAX_LENGTH).required(intl.formatMessage(messages.required)),
    esLabel: stringValidation(intl, MIN_LENGTH, MAX_LENGTH).required(intl.formatMessage(messages.required)),
    type: stringValidation(intl, MIN_LENGTH, MAX_LENGTH).required(intl.formatMessage(messages.required)),
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.required)),
      name: yup.string()
    }),
    price: yup.string().required(intl.formatMessage(messages.required)),
    salesChannels: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string().required(),
          name: yup.string().required(),
          country: yup.object().shape({
            id: yup.string(),
            currency: yup.object().shape({
              id: yup.string(),
              code: yup.string()
            })
          })
        })
      )
      .min(1, intl.formatMessage(messages.required))
  })
}
